/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { VIEW_MODE } from '../components/login/login.util'
import { LOGIN_MODE } from '../components/login/login.util'
import { OTPLogin } from '../components/login/otp-login'
import { QrCodeLogin } from '../components/login/qr-code-login'
import { EmailOTPLogin } from '../components/login/email-login'
import PublicLayout from '../layouts/public.layouts'
import { useParams } from 'react-router-dom'
import AWS from 'aws-sdk'
import { setLocalAuthDetails, decryptData } from '../utils/common.util'
import {
  AUTH_PAYLOAD,
  AUTH_SESSION_CHECK,
  AUTH_SESSION_DATA,
} from '../utils/constant'
import { useAuthContext } from '../context/auth.context'
import { loginConst } from '../utils/action.constant'
import { useCognitoSignIn } from '../hooks/login.hooks'
import { useHistory } from 'react-router'
import OrganizationListView from './../components/login/organization-list'

import { ActiveDirectoryLogin } from '../components/login/activeDirectory-login'

export default function LoginPage(props) {
  const [loginViewMode, setLoginViewMode] = useState(VIEW_MODE.QR)
  const urlParams = useParams()
  const [loginError, setLoginError] = useState(false)
  const { mutate } = useCognitoSignIn()
  const { dispatch } = useAuthContext()
  const history = useHistory()

  useEffect(() => {
    console.log(urlParams)
    if (!!urlParams.params) {
      const authData = decryptData(urlParams.params)
      setLogin(authData)
    }
  }, [])

  const ENUM_VIEW_COMPONENT = {
    [VIEW_MODE.OTP]: (
      <PublicLayout>
        <OTPLogin setLoginViewMode={setLoginViewMode} />
      </PublicLayout>
    ),
    [VIEW_MODE.EMAIL]: (
      <PublicLayout>
        <EmailOTPLogin setLoginViewMode={setLoginViewMode} />
      </PublicLayout>
    ),
    [VIEW_MODE.QR]: (
      <PublicLayout>
        <QrCodeLogin setLoginViewMode={setLoginViewMode} />
      </PublicLayout>
    ),
    [VIEW_MODE.ACTIVE_DIRECTORY]: (
      <PublicLayout>
        <ActiveDirectoryLogin setLoginViewMode={setLoginViewMode} />
      </PublicLayout>
    ),
    [VIEW_MODE.ORG]: <OrganizationListView />,
  }

  const onSetAwsConfig = ({ idToken }) => {
		// Set the region where your identity pool exists (us-east-1, eu-west-1)
		AWS.config.region = process.env.REACT_APP_AWS_REGION

		// Configure the credentials provider to use your identity pool
		AWS.config.credentials = new AWS.CognitoIdentityCredentials({
			IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
			Logins: {
				[`cognito-idp.ap-south-1.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`]:
					idToken.jwtToken,
			},
		})
	}

  const setLogin = authData => {
    localStorage.setItem(AUTH_PAYLOAD, authData)
    const auth = JSON.parse(atob(authData))
    mutate(auth, {
      onSuccess: data => {
        setLocalAuthDetails({
          account_id: auth.accountId,
          asset_id: auth.assetId,
          asset_token_auth: auth.encToken,
          asset_encryption_token_id: auth.encToken,
          organization_id: auth.organizationId,
          workforce_id: auth.workforceId,
        })
        dispatch({
          type: loginConst.LOGIN,
          payload: {
            ...auth,
            ...data,
          },
        })
        sessionStorage.setItem(AUTH_SESSION_CHECK, true)
        sessionStorage.setItem(AUTH_SESSION_DATA, JSON.stringify(data))
        onSetAwsConfig(data)
        history.push('/idcard')
      },
      onError: error => {
        console.log('error', error)
        setLoginError(true)
        dispatch({
          type: loginConst.LOGIN_IN_FAILED,
          payload: {
            error,
          },
        })
      },
    })
  }

  return <>{ENUM_VIEW_COMPONENT[loginViewMode]}</>
}
